import GenericDictionaryPage from "./GenericDictionaryPage";
import { getImprovementPlanType } from "../api/improvementPlanType";

export default function ImprovementPlanType() {
    return (
        <GenericDictionaryPage
            tableKey="improvementPlanType"
            fetchData={getImprovementPlanType}
            titleKey="genericDic:improvementPlanType"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:improvementPlanType").toLowerCase()
                })
            }
        />
    );
}
